import Tone from 'tone';

const TIME_32N = new Tone.Time('32n');

export function extractGroove(onsets, sampleTempo, sequenceTempo) {
    let firstOnset = onsets[0];
    let steps = onsets.map(
        onset => convertOnset(onset - firstOnset, sampleTempo, sequenceTempo));

    let timing32 = getTimingForResolution(steps, 32);
    let cSteps = subtractOffset(steps, 32, timing32);
    let timing16 = getTimingForResolution(cSteps, 16);
    cSteps = subtractOffset(cSteps, 16, timing16);
    let timing8  = getTimingForResolution(cSteps, 8);
    cSteps = subtractOffset(cSteps, 8, timing8);
    let timing4  = getTimingForResolution(cSteps, 4);
    cSteps = subtractOffset(cSteps, 4, timing4);
    let timing2  = getTimingForResolution(cSteps, 2);
    cSteps = subtractOffset(cSteps, 2, timing2);
    let timing1  = getTimingForResolution(cSteps, 1);
    cSteps = subtractOffset(cSteps, 1, timing1);
    console.log('timing 1 = ');
    console.log(timing1);

    return {
        steps: cSteps,
        unquantizedSteps: steps,
        timings: [timing1, timing2, timing4, timing8, timing16, timing32]
            .filter(x => !isTimingEmpty(x))
    };
}

function isTimingEmpty(timing) {
    return timing.even === 0 && timing.odd === 0;
}

function subtractOffset(steps, resolution, timing) {
    let numSteps = 32 / resolution;

    return steps.map(
        step => ({
            stepNumber: step.stepNumber,
            offset: Math.max(
                0,
                Math.floor(step.stepNumber / numSteps) % 2 === 0 ?
                    step.offset - timing.even :
                    step.offset - timing.odd)
        }));
}

function getTimingForResolution(steps, resolution) {
    let numSteps = 32 / resolution;

    let minOddOffset = undefined;
    let minEvenOffset = undefined;
    for (let i in steps) {
        let step = steps[i];
        let stepNumber = step.stepNumber;
        let offset = step.offset;

        if (Math.floor(stepNumber / numSteps) % 2 === 0) {
            if (resolution === 1) {
                console.log('even for 1 offset = ' + offset);
            }

            if (minEvenOffset === undefined ||
                minEvenOffset > offset) {
                minEvenOffset = offset;
            }
        } else {
            if (resolution === 1) {
                console.log('odd for 1 offset = ' + offset);
            }
            if (minOddOffset === undefined ||
                minOddOffset > offset) {
                minOddOffset = offset;
            }
        }
    }

    return {
        resolution: resolution,
        even: minEvenOffset || 0,
        odd: minOddOffset || 0
    };
}

// algo for finding timing constnats:
// start with biggest resolution (i.e. 1/4)
// choose the minimum even and odd values here
// subratct these values from the steps

function clearSteps(steps) {
    return steps.map(
        s => ({
            stepNumber: s.stepNumber,
            offset: 0
        }));
}

function diff(steps1, steps2) {
    let sum = 0;
    let count = 0;
    for (let i in steps1) {
        let diff = Math.abs(steps1[i].offset - steps2[i].offset);
        sum+=diff;
        count++;
    }

    return sum / count;
}

export function convertOnset(onset, sampleTempo, sequenceTempo) {
    let time = onset * sampleTempo / sequenceTempo;
    let stepNumber = time / TIME_32N.toMilliseconds();
    let offset = stepNumber - Math.floor(stepNumber);
    return {
        stepNumber: Math.floor(stepNumber),
        offset: offset,
    };
}
